import { Fragment } from "react";
// import Banner from '../components/Banner';
import Landing from "../components/Landing"


export default function Home() {

    return (
        <Fragment>
            <Landing/>
        </Fragment>
    )
}